import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import GiftCard1 from 'components/GiftCard1';
import * as styles from './styles/styles.module.scss';

const {
  GIFT_FLOW: {
    AN_EASY_WAY,
    SEND_THE_GIFT_OF_EXPLORATION,
    QUICK_AND_EASY,
    PURCHASE_EASILY,
    CUSTOMIZABLE,
    CHOOSE_LENGTH_OF_PLAN,
    SEND_VIA_EMAIL_PRINT,
    CHOOSE_DELIVERY_DATE,
    PERFECT_FOR_ALL_OCCASIONS,
    CELEBRATE_THE_PEOPLE,
    AND_MORE,
    ALT_TEXT: { FRIENDS_AT_THE_SUMMIT, TWO_CYCLISTS, PERSON_TRAIL_RUNNING, PERSON_CYCLING },
    ATHLETES: { HIKERS, MOUNTAIN_BIKERS, TRAIL_RUNNERS, BACKPACKERS, ROAD_BIKERS, ROCK_CLIMBERS, SNOWSHOERS, SKIERS }
  }
} = StringConstantsMixin.strings;

const AT_ATHLETES = [HIKERS, MOUNTAIN_BIKERS, TRAIL_RUNNERS, BACKPACKERS, ROAD_BIKERS, ROCK_CLIMBERS, SNOWSHOERS, SKIERS];

const ValueBlurb = ({ title, content }) => (
  <div className={styles.subHeadAndSubText}>
    <h4 className={styles.subHeader}>{title}</h4>
    <div className={styles.subText}>{content}</div>
  </div>
);

const GiveJoy = () => (
  <section>
    <div className={styles.headerAndSubText}>
      <h2 className={styles.header}>{AN_EASY_WAY}</h2>
      <div className={styles.subText}>{SEND_THE_GIFT_OF_EXPLORATION}</div>
    </div>
    <div className={styles.imageAndBlurbs}>
      <div>
        <div className={styles.gc}>
          <GiftCard1 />
        </div>
      </div>
      <div className={styles.blurbs}>
        <ValueBlurb title={QUICK_AND_EASY} content={PURCHASE_EASILY} />
        <ValueBlurb title={CUSTOMIZABLE} content={CHOOSE_LENGTH_OF_PLAN} />
        <ValueBlurb title={SEND_VIA_EMAIL_PRINT} content={CHOOSE_DELIVERY_DATE} />
      </div>
    </div>
  </section>
);

const PerfectForAll = () => (
  <section className={styles.perfectForAllContainer}>
    <div className={styles.headerAndSubText}>
      <h2 className={styles.header}>{PERFECT_FOR_ALL_OCCASIONS}</h2>
      <div className={styles.subText}>{CELEBRATE_THE_PEOPLE}</div>
    </div>
    <div className={styles.imageGrid}>
      <div className={styles.leftImageColumn}>
        <img
          className={`${styles.largeImage} lazyload`}
          data-src="https://cdn-assets.alltrails.com/assets/images/gifting/image-a@2x.png"
          alt={FRIENDS_AT_THE_SUMMIT}
        />
        <div className={styles.subImages}>
          <img
            className={`${styles.imageA} lazyload`}
            data-src="https://cdn-assets.alltrails.com/assets/images/gifting/image-b@2x.png"
            alt={TWO_CYCLISTS}
          />
          <img
            className={`${styles.imageA} lazyload`}
            data-src="https://cdn-assets.alltrails.com/assets/images/gifting/image-c@2x.png"
            alt={PERSON_TRAIL_RUNNING}
          />
        </div>
      </div>
      <div className={styles.rightImageColumn}>
        <img
          className={`${styles.imageC} lazyload`}
          data-src="https://cdn-assets.alltrails.com/assets/images/gifting/image-d@2x.png"
          alt={PERSON_CYCLING}
        />
        <div className={styles.athleteList}>
          {AT_ATHLETES.map(athlete => (
            <div key={athlete}>{athlete}</div>
          ))}
          <div className={styles.andMore}>{AND_MORE}...</div>
        </div>
      </div>
    </div>
  </section>
);

const GiftValuePanel = () => (
  <div className={styles.container}>
    <GiveJoy />
    <PerfectForAll />
  </div>
);

export default GiftValuePanel;
